import { apiInstance } from "config/baseUrl";
import axios from "axios";
import { useQuery } from "react-query";

export const useFetch = (queryKey, url, options, post = false, refetch) => {
  const accessToken = window.localStorage.getItem("token");

  return useQuery({
    queryKey: [queryKey],
    queryFn: async () => {
      const isAbsoluteUrl = url?.startsWith("http");

      const instance = isAbsoluteUrl
        ? axios.create() // no baseURL, use URL as-is
        : apiInstance;

      return await instance({
        method: post ? "POST" : "GET",
        url: url,
        headers: {
          Insytsjwt: accessToken,
        },
        data: post,
      })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    refetchOnWindowFocus: false,
    refetch,
    ...options,
  });
};